"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerArticle = void 0;

var react_1 = __importDefault(require("react"));

var ContainerArticle = function ContainerArticle(_a) {
  var children = _a.children,
      backgroundImage = _a.backgroundImage,
      theme = _a.theme;
  var style = "w-full m-0 p-0 " + (theme ? theme.body.backgroundColor + " " + theme.body.textColor : "bg-gray-100 text-gray-800");

  if (typeof window !== "undefined" && backgroundImage) {
    // document.body.style.background = `linear-gradient(to bottom, #0b3536 0%, rgba(125, 185, 232, 0)), url(${backgroundImage})`;
    document.body.style.backgroundImage = "linear-gradient(to bottom, #0b3536 0%, rgba(125, 185, 232, 0)), url(" + backgroundImage + ")";
    document.body.style.backgroundAttachment = "fixed";
    document.body.style.backgroundSize = "cover";
  }

  return react_1["default"].createElement("article", {
    className: style
  }, children);
};

exports.ContainerArticle = ContainerArticle;